<template>
  <div class="notification-bar">
    {{ notification.message }}
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      timeout: null,
    }
  },
  mounted() {
    this.timeout = setTimeout(() => this.remove(this.notification), 5000)
  },
  unmounted() {
    clearTimeout(this.timeout)
  },
  methods: mapActions('notification', ['remove']),
}
</script>

<style>
.notification-bar {
  background-color: rgb(139, 199, 81, 0.9);
  color: #ffffff;
  width: 100%;
  padding: 12px 15px;
  text-align: center;
  width: 100%;
  max-width: 450px;
  margin: 0 auto;
  font-size: 20px;
  line-height: 28px;
}
</style>
